export const conversationTabs = (id, { current, canReadProfile = true }) =>
  [
    { id: 'messages', name: 'Messages', to: `/messages/${id}` },
    canReadProfile && { id: 'profile', name: 'Profile', to: `/profile/${id}` }
  ]
    .filter(Boolean)
    .map(tab => ({ ...tab, active: tab.id === current }))

export const conversationParent = { name: 'Messages', link: '/messages' }

export default {
  bases: ['/messages', '/profile'],
  fetches: [],
  build: () => []
}
